/*
 * TTG Kopfsuche (Briefing rassesuche-nacharbeit, 03.11.2026): Block „Hunderassen“ über den Shopify-Suchvorschlägen im Kopf.
 * Daten erst beim ersten Fokus in die Suchleiste: /pages/rassesuche?view=rassen-daten (templates/page.rassen-daten.liquid,
 * Quelle snippets/ttg-rassen-daten.liquid), im Browser in sessionStorage zwischengespeichert. Suchlogik und Rang aus
 * assets/ttg-rassesuche.js (window.ttgRassesuche.suchen); gezeigt werden nur Treffer mit Rang 0–2 (Name oder Synonym beginnt
 * mit der Eingabe), keine Gruppen, höchstens 3.
 * Den Platzhalter [data-ttg-kopf-rassen] liefert sections/predictive-search.liquid bei jeder Antwort neu (morph); dieses Skript
 * füllt ihn. Die Einträge tragen ref="resultsItems[]" in einer .predictive-search-results__list – so laufen Pfeile und Enter
 * der Theme-Suche (assets/predictive-search.js) über beide Blöcke. Klick meldet ttg_kopfsuche_rasse.
 */
(function () {
  'use strict';
  var skript = document.currentScript;
  if (!skript) return;
  var DATEN_URL = skript.getAttribute('data-daten');
  var SUCHE_URL = skript.getAttribute('data-suche');
  var SPEICHER = 'ttg-rassen-daten-v1';
  var daten = null, laedt = null, beobachtet = false;

  function rassesucheLaden() {
    if (window.ttgRassesuche) return Promise.resolve();
    return new Promise(function (ok, fehler) {
      var e = document.createElement('script');
      e.src = SUCHE_URL; e.onload = ok; e.onerror = fehler;
      document.head.appendChild(e);
    });
  }

  function jsonLaden() {
    try {
      var c = sessionStorage.getItem(SPEICHER);
      if (c) return Promise.resolve({ text: c, quelle: 'speicher' });
    } catch (e) {}
    return fetch(DATEN_URL, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (t) {
      try { sessionStorage.setItem(SPEICHER, t); } catch (e) {}
      return { text: t, quelle: 'netz' };
    });
  }

  function vorbereiten(d) {
    var norm = window.ttgRassesuche.norm;
    d.r.forEach(function (r) { r.nn = norm(r.n); r.ns = r.s.map(norm); });
    d.g.forEach(function (g) { g.na = g.a.map(norm); });
    return d;
  }

  function laden() {
    if (laedt) return laedt;
    var t0 = performance.now();
    laedt = Promise.all([rassesucheLaden(), jsonLaden()]).then(function (x) {
      daten = vorbereiten(JSON.parse(x[1].text));
      window.__ttgKopfsuche = { ms: Math.round(performance.now() - t0), bytes: x[1].text.length, quelle: x[1].quelle, rassen: daten.r.length };
      alleFuellen();
    }).catch(function () { laedt = null; });
    return laedt;
  }

  // Passenden Teil fett (wie assets/ttg-rassesuche.js): kürzester Ausschnitt ab einem Wortanfang mit derselben Normalform.
  function hervorheben(text, eingabe, ziel) {
    var norm = window.ttgRassesuche.norm, q = norm(eingabe), i, j;
    for (i = 0; i < text.length; i++) {
      if (i > 0 && /[0-9A-Za-zÀ-ž]/.test(text[i - 1])) continue;
      for (j = i + 1; j <= text.length; j++) {
        var n = norm(text.slice(i, j));
        if (n === q) {
          ziel.appendChild(document.createTextNode(text.slice(0, i)));
          var b = document.createElement('strong'); b.textContent = text.slice(i, j); ziel.appendChild(b);
          ziel.appendChild(document.createTextNode(text.slice(j)));
          return;
        }
        if (n.length > q.length + 2) break;
      }
    }
    ziel.appendChild(document.createTextNode(text));
  }

  // Enter klickt den Link evtl. zweimal (eigene Enter-Behandlung und Theme-Logik): dieselbe Rasse innerhalb 1 s nur einmal melden.
  var zuletzt = { name: '', t: 0 };
  function melden(name) {
    var jetzt = Date.now();
    if (zuletzt.name === name && jetzt - zuletzt.t < 1000) return;
    zuletzt = { name: name, t: jetzt };
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ttg_kopfsuche_rasse', { rasse: name }); } catch (e) {}
  }

  function fuellen(box) {
    // Titel wie „Produkte“: Klasse des Themes erst im Browser (im Liquid wäre sie für den Theme-Check fremd).
    var titel = box.querySelector('.ttg-kopf-rassen__titel');
    if (titel && !titel.classList.contains('predictive-search-results__title')) titel.classList.add('predictive-search-results__title');
    var q = box.getAttribute('data-q') || '';
    if (!daten || box.getAttribute('data-gefuellt') === q) return;
    box.setAttribute('data-gefuellt', q);
    var liste = box.querySelector('ul');
    if (!liste) return;
    liste.innerHTML = '';
    var e = window.ttgRassesuche.suchen(daten, q);
    var t = (e.art === 'treffer' ? e.treffer : []).filter(function (x) { return x.rang <= 2; }).slice(0, 3);
    t.forEach(function (x) {
      var li = document.createElement('li');
      li.className = 'ttg-kopf-rasse';
      li.setAttribute('ref', 'resultsItems[]');
      var a = document.createElement('a');
      a.className = 'ttg-kopf-rasse__link';
      a.href = x.r.u;
      if (x.r.b) {
        var img = document.createElement('img');
        img.src = x.r.b; img.alt = ''; img.width = 48; img.height = 48; img.className = 'ttg-kopf-rasse__bild';
        a.appendChild(img);
      }
      var txt = document.createElement('span'); txt.className = 'ttg-kopf-rasse__text';
      var name = document.createElement('span'); name.className = 'ttg-kopf-rasse__name';
      if (x.rang <= 1 && !x.syn) hervorheben(x.r.n, q, name); else name.textContent = x.r.n;
      txt.appendChild(name);
      if (x.syn) {
        var auch = document.createElement('span'); auch.className = 'ttg-kopf-rasse__auch';
        auch.appendChild(document.createTextNode('auch: '));
        var s = document.createElement('span'); hervorheben(x.syn, q, s); auch.appendChild(s);
        txt.appendChild(auch);
      }
      a.appendChild(txt);
      a.addEventListener('click', function () { melden(x.r.n); });
      li.appendChild(a);
      liste.appendChild(li);
    });
    box.hidden = t.length === 0;
  }

  function alleFuellen() {
    document.querySelectorAll('[data-ttg-kopf-rassen]').forEach(fuellen);
  }

  function beobachten() {
    if (beobachtet || !window.MutationObserver) return;
    var wurzel = document.querySelector('predictive-search-component');
    if (!wurzel) return;
    beobachtet = true;
    new MutationObserver(function () { if (daten) alleFuellen(); }).observe(wurzel, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-q'] });
  }

  // Erster Fokus lädt die Daten; das erste Tippen auch (falls der Fokus vor dem Laden des Skripts lag).
  function start(ev) {
    var t = ev.target;
    if (t && t.matches && t.matches('predictive-search-component input[type="search"]')) { beobachten(); laden(); }
  }
  document.addEventListener('focusin', start);
  document.addEventListener('input', start);

  // Enter auf einer markierten Rasse: vor der Theme-Logik (die bei genau einem Shopify-Treffer sonst dorthin springt).
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter') return;
    var t = ev.target;
    if (!t || !t.matches || !t.matches('predictive-search-component input[type="search"]')) return;
    var gewaehlt = document.querySelector('.ttg-kopf-rasse[aria-selected="true"] a');
    if (!gewaehlt) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    gewaehlt.click();
  }, true);

  var stil = document.createElement('style');
  stil.textContent = '.ttg-kopf-rassen{padding-inline:var(--padding-xl);margin-block-end:20px}' +
    '.ttg-kopf-rassen__liste{display:flex;flex-direction:column;gap:2px;margin:0 0 20px;padding:0}' +
    '.ttg-kopf-rasse__link{display:flex;align-items:center;gap:12px;min-height:44px;padding:6px 8px;border-radius:10px;color:inherit;text-decoration:none}' +
    '.ttg-kopf-rasse__link:hover,.ttg-kopf-rasse[aria-selected="true"] .ttg-kopf-rasse__link{background:rgb(var(--color-foreground-rgb) / .06)}' +
    '.ttg-kopf-rasse.keyboard-focus .ttg-kopf-rasse__link{outline:2px solid currentColor;outline-offset:-2px}' +
    '.ttg-kopf-rasse__bild{flex:none;width:48px;height:48px;border-radius:10px;object-fit:cover;background:#eef3f6}' +
    '.ttg-kopf-rasse__text{display:flex;flex-direction:column;gap:2px}' +
    '.ttg-kopf-rasse__name{font-weight:700}' +
    '.ttg-kopf-rasse__auch{font-size:.875em;opacity:.75}';
  document.head.appendChild(stil);
})();
